module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container u-relative"
  }, [_c('div', {
    staticClass: "c-watch-now__player o-box--20by9 u-fit-w u-relative u-vacuum u-marg-b-md"
  }, [_c('div', {
    staticClass: "c-watch-now__video u-absolute u-pos-tl u-fit-h u-inline-block js-twitch-player",
    class: {
      'u-hide': !this.$root.isChannelLive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-watch-now__offline c-watch-now__video o-wrapper--valign u-absolute u-pos-tl u-fit-h u-inline-block u-bg--black u-pointer-none",
    class: {
      'u-hide': this.$root.isChannelLive
    }
  }, [_c('p', {
    staticClass: "t-text--xl t-lspacing--md u-uppercase u-align-center u-valign-middle u-inline-block u-fit-w",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.offline)
    }
  })]), _vm._v(" "), (_vm.$root.isChannelLive) ? _c('iframe', {
    staticClass: "c-watch-now__chat u-absolute u-pos-tr u-fit-h",
    attrs: {
      "frameborder": "0",
      "scrolling": "no",
      "src": _vm.contentGlobal.twitch.embedChatUrl
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "u-align-left u-marg-b-xxxl"
  }, [_c('app-btn', {
    staticClass: "u-valign-middle u-marg-l-xxxs",
    on: {
      "click": function($event) {
        _vm.openModalRegister()
      }
    }
  }, [_c('span', {
    staticClass: "c-register-btn-icon__container u-inline-block"
  }, [_c('img', {
    staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
    attrs: {
      "src": require("../../../assets/icon/icon-register--arrow.png")
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.support)
    }
  })])], 1), _vm._v(" "), _c('h2', {
    staticClass: "t-h4 u-uppercase u-inline-block u-marg-l-w1of16 u-valign-top u-marg-b-xxxl u-marg-l-0@md u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.socialTitle)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-marg--before-footer"
  }, [_c('nav', {
    staticClass: "u-align-center"
  }, _vm._l((_vm.socialList), function(column, index) {
    return (_vm.socialList.length > 0) ? _c('div', {
      staticClass: "c-hub-social-column u-inline-block u-valign-top"
    }, _vm._l((column), function(social, i) {
      return (i < _vm.columnLength) ? _c('app-fadein', {
        key: social.key,
        attrs: {
          "delay": index * 70
        }
      }, [_c('app-hub-item', {
        staticClass: "u-marg-x-lg",
        attrs: {
          "content": social
        },
        on: {
          "load": function($event) {
            _vm._sortSocial()
          }
        }
      })], 1) : _vm._e()
    })) : _vm._e()
  })), _vm._v(" "), (_vm.isMoreBtnEnable) ? _c('div', {
    staticClass: "u-align-center"
  }, [_c('app-btn', {
    on: {
      "click": function($event) {
        _vm._moreSocial()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.more)
    }
  })])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d541665a"}!./src/scripts/components/page-watch-now/template.html
// module id = 946
// module chunks = 0